const shadows = {
  sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  DEFAULT: 'rgba(0, 0, 0, 0.25) 0px 1px 4px',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  '2xl': '0 25px 50px -12px rgb(0 0 0 / 0.25)',
  inner: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.05)',
  innerBottom: 'inset 0px -6px 10px  rgb(0 0 0 / 0.05);',
  excludingTop: 'rgba(0, 0, 0, 0.15) 0px 1.95px 2.6px;',
  onlyBottom: '0 6px 4px -4px rgba(0, 0, 0, 0.15)',
  cardShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 6px',
  none: 'none',
}
export default shadows
